import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../interfaces';
import { Car, CreateCarDto, UpdateCarDto } from '../interfaces/car.interface';
import { CarParameterData } from '../interfaces/parameter.interface';

@Injectable({
  providedIn: 'root'
})
export class CarsService {
  private readonly apiUrl = '/api/company/cars';

  constructor(private http: HttpClient) {}

  getCars(includeSold = false): Observable<ApiResponse<Car[]>> {
    let params = new HttpParams();
    if (includeSold) {
      params = params.set('includeSold', 'true');
    }
    return this.http.get<ApiResponse<Car[]>>(this.apiUrl, { params });
  }

  getCarById(id: number): Observable<ApiResponse<Car>> {
    return this.http.get<ApiResponse<Car>>(`${this.apiUrl}/${id}`);
  }

  createCar(dto: CreateCarDto): Observable<ApiResponse<Car>> {
    return this.http.post<ApiResponse<Car>>(this.apiUrl, dto);
  }

  updateCar(id: number, dto: UpdateCarDto): Observable<ApiResponse<Car>> {
    return this.http.put<ApiResponse<Car>>(`${this.apiUrl}/${id}`, dto);
  }

  deleteCar(id: number): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }

  toggleActive(id: number): Observable<ApiResponse<Car>> {
    return this.http.put<ApiResponse<Car>>(`${this.apiUrl}/${id}/toggle-active`, {});
  }

  // Car Parameters Management
  getAssignedParameters(carId: number): Observable<ApiResponse<CarParameterData[]>> {
    return this.http.get<ApiResponse<CarParameterData[]>>(`${this.apiUrl}/${carId}/parameters`);
  }

  getAvailableParameters(carId: number): Observable<ApiResponse<CarParameterData[]>> {
    return this.http.get<ApiResponse<CarParameterData[]>>(`${this.apiUrl}/${carId}/parameters/available`);
  }

  assignParameters(carId: number, parameterIds: number[]): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${carId}/parameters`, { parameterIds });
  }

  unassignParameters(carId: number, parameterIds: number[]): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${carId}/parameters`, { 
      body: { parameterIds } 
    });
  }
}
